var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:"onboardingVideo",staticClass:"flex flex-col items-end",staticStyle:{"pointer-events":"all"}},[(_setup.$user.isCompany)?_c('CompanyOnboardingVideoSmall'):_c('TalentOnboardingVideo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }